@if (appearance === FormSectionAppearance.Accordion) {
  @if (isStandalone) {
    <ti-portlet
      class="dfs-portlet"
      [class.state-active]="state === 'active'"
      [collapsed]="collapsed"
      (collapsedChange)="handleCollapsedChange($event)">
      <ng-template tiPortletTemplateHeader>
        <div class="dfs-section-title">
          <span [tiOverflowTooltip]="{ mode: 'white-background', static: false }">{{ title }}</span>
          @if (metadata) {
            <ti-section-metadata [data]="metadata"></ti-section-metadata>
          }
        </div>
      </ng-template>
      <ng-template tiPortletTemplateContent>
        <ng-container *ngTemplateOutlet="SectionContent"></ng-container>
      </ng-template>
    </ti-portlet>
  } @else {
    <ti-modern-section
      [title]="title"
      appearance="slim"
      [hasBodyPadding]="true"
      [expanded]="!collapsed"
      [state]="state"
      (expandedChange)="handleCollapsedChange(!$event)">
      <ng-container *ngTemplateOutlet="SectionContent"></ng-container>
      <div left-section-title *ngIf="metadata">
        <ti-section-metadata [data]="metadata"></ti-section-metadata>
      </div>
    </ti-modern-section>
  }
} @else {
  <ti-card [appearance]="isStandalone ? 'default' : 'slim'">
    <h3 class="section-title" *ngIf="title">{{ title }}</h3>
    <ng-container *ngTemplateOutlet="SectionContent"></ng-container>
  </ti-card>
}

<ng-template #SectionContent>
  <ng-content></ng-content>
</ng-template>
